export const DOLAR_PIRULO: number = 1200;